export function FooterHeight(state = 0, action) {
  switch (action.type) {
    case 'SET_FOOTER_HEIGHT': {
      return action.payload
    }
    default:
      return state
  }
}
